import { ErrorType, LoadedType, RequestType } from 'common/actions/assessment';

import requestReducerFactory from './requestReducerFactory';

export default requestReducerFactory(RequestType, LoadedType, ErrorType);
